import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, Validator, ValidatorFn, Validators } from "@angular/forms";

@Component({
    selector: 'lok-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: false
})
export class CustomInputComponent {
    @Input() control: FormControl = new FormControl('');
    @Input() label: string | undefined;
    @Input() showError = false;
    @Input() type = 'text';
    @Input() textOnly = false;
    @Input() iconUrl = '';
    @Input() placeholder = '';
    @Input() readonly = false;
    @Output() iconClick = new EventEmitter();
    requiredValidator: ValidatorFn = Validators.required;

    getErrorMessage () {
        let message = 'enterValueError';
        if (this.control.hasError('max')) {
            message = 'amountExceedsError';
        } else if (this.control.hasError('min')) {
            message = 'enterCorrectDataError';
        } else if(this.control.hasError('notANumber')){
            message = 'itAccpetsNumbericValues';
        } else if(this.control.hasError('invalidQuarterDays')){
            message = 'inputExceedDaysInThisQuarter';
        } else if(this.control.hasError('alphanumeric')){
            message = 'itAcceptsAlphanumericValues';
        }
        return message;
    }

    onKeyPress (event: KeyboardEvent) {
        if (this.textOnly) {
            const pattern = /[A-Za-z ]/;
            const inputChar = String.fromCharCode(event.charCode);
            if (!pattern.test(inputChar)) {
                event.preventDefault();
            }
        }
    }

    iconClicked (){
        this.iconClick.emit();
    }
}